import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import Sound from 'react-sound';
import giftbox from '../../assets/animations/giftbox-unbox.json';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import FullScreenDialog, { FullScreenDialogProps } from '../FullScreenDialog';

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(15),
    overflow: 'hidden',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  vip: {
    fontWeight: theme.typography.fontWeightBold,
    color: '#ffae23',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  fillRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: theme.palette.primary.main,
    width: 60,
    height: 60,
    borderRadius: 60 / 2,
    backgroundColor: theme.palette.primary.main,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  icon: {
    color: theme.palette.primary.main,
  },
  timestamp: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  box: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  close: {
    marginLeft: 'auto',
  },
  closeIcon: {
    color: theme.palette.common.black,
  },
}));

type Props = Pick<FullScreenDialogProps, 'open' | 'onClose'>;

export default function RewardUnlockSuccessDialog({ onClose, open }: Props) {
  const classes = useStyles();
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMusicPlaying, setIsMusicPlaying] = useState(true);

  useEffect(() => {
    if (!isMusicPlaying && onClose) {
      setTimeout(() => onClose({}, 'backdropClick'), 3000);
    }
  }, [onClose, isMusicPlaying]);

  return (
    <FullScreenDialog open={open}>
      <Sound
        url={'../sound/tada.mp3'}
        playStatus={isMusicPlaying ? 'PLAYING' : 'STOPPED'}
        onFinishedPlaying={() => setIsMusicPlaying(false)}
      />
      <div className={classes.box}>
        <div className={classes.close}>
          <IconButton
            onClick={() => {
              if (onClose) {
                onClose({}, 'backdropClick');
              }
            }}
          >
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </div>
      </div>
      <div className={classes.cardContainer}>
        <Typography variant="h4" className={classes.title} gutterBottom>
          Reward unlocked!
        </Typography>
        {isPlaying && (
          <Lottie
            animationData={giftbox}
            loop={isPlaying}
            autoplay={false}
            style={{ height: 200, width: 300 }}
            onComplete={() => setIsPlaying(false)}
          />
        )}
      </div>
    </FullScreenDialog>
  );
}
